import React from 'react';

import DeliveryBadge from './DeliveryBadge';
import EmailStatusBadge from './EmailStatusBadge';

const EmailTable = ({
	emails,
	sortBy,
	sortOrder,
	onSort,
	onViewDetails,
	onRetry,
}) => {
	// Format date helper
	const formatDate = (dateString) => {
		if (!dateString) return '-';
		try {
			return dateString;
			// return formatDistanceToNow(new Date(dateString), { addSuffix: true });
		} catch {
			return dateString;
		}
	};

	// Get type badge
	const getTypeBadge = (type) => {
		const labels = {
			alert: 'Alert',
			notification: 'Notification',
			expiring1: 'Expiring 1D',
			expiring7: 'Expiring 7D',
			expiring14: 'Expiring 14D',
			reminder: 'Reminder',
		};

		return <span className="badge bg-info">{labels[type] || type}</span>;
	};

	const getSmsBadge = (email) => {
		if (!email.sms) {
			return <span className="text-muted">—</span>;
		}

		const badges = {
			pending: 'bg-warning',
			sent: 'bg-success',
			sent_digest: 'bg-info',
			failed: 'bg-danger',
		};
		const labels = {
			pending: 'pending',
			sent: 'sent',
			sent_digest: 'digest',
			failed: 'failed',
		};

		return (
			<span className={`badge ${badges[email.sms.status] || 'bg-secondary'}`}>
				{labels[email.sms.status] || email.sms.status}
			</span>
		);
	};

	// Sort icon
	const getSortIcon = (column) => {
		if (sortBy !== column) {
			return <i className="bi bi-arrow-down-up text-muted ms-1" />;
		}
		return sortOrder === 'asc' ? (
			<i className="bi bi-arrow-up ms-1" />
		) : (
			<i className="bi bi-arrow-down ms-1" />
		);
	};

	return (
		<div className="table-responsive">
			<table className="table table-hover mb-0">
				<thead className="table-light">
					<tr>
						<th
							style={{ cursor: 'pointer' }}
							onClick={() => onSort('to_email')}
						>
							Recipient {getSortIcon('to_email')}
						</th>
						<th>Subject</th>
						<th style={{ cursor: 'pointer' }} onClick={() => onSort('status')}>
							Status {getSortIcon('status')}
						</th>
						<th>Delivery</th>
						<th>Type</th>
						<th>SMS</th>
						<th
							style={{ cursor: 'pointer' }}
							onClick={() => onSort('created_at')}
						>
							Created {getSortIcon('created_at')}
						</th>
						<th style={{ cursor: 'pointer' }} onClick={() => onSort('sent_at')}>
							Sent {getSortIcon('sent_at')}
						</th>
						<th>Attempts</th>
						<th className="text-end">Actions</th>
					</tr>
				</thead>
				<tbody>
					{emails.map((email) => (
						<tr key={email.id}>
							<td>
								<div>
									<div className="fw-medium">{email.to_email}</div>
									{email.user && (
										<small className="text-muted">{email.user.name}</small>
									)}
								</div>
							</td>
							<td>
								<div className="text-truncate" style={{ maxWidth: '250px' }}>
									{email.subject || (
										<span className="text-muted">No subject</span>
									)}
								</div>
								{email.property && (
									<small className="text-muted d-block">
										<i className="bi bi-building me-1" />
										{email.property.address}
									</small>
								)}
							</td>
							<td>
								<EmailStatusBadge email={email} />
							</td>
							<td>
								<DeliveryBadge status={email.delivery_status} testId="email-delivery" />
							</td>
							<td>{getTypeBadge(email.type)}</td>
							<td>{getSmsBadge(email)}</td>
							<td>
								<small>{formatDate(email.created_at)}</small>
							</td>
							<td>
								<small>
									{email.sent_at ? (
										formatDate(email.sent_at)
									) : (
										<span className="text-muted">-</span>
									)}
								</small>
							</td>
							<td>
								{email.attempts > 0 ? (
									<span
										className={`badge ${
											email.attempts > 2 ? 'bg-danger' : 'bg-warning'
										}`}
									>
										{email.attempts}
									</span>
								) : (
									<span className="text-muted">0</span>
								)}
							</td>
							<td className="text-end">
								<div className="btn-group btn-group-sm">
									<button
										className="btn btn-primary"
										onClick={() => onViewDetails(email)}
										title="View Details"
									>
										<i className="bi bi-eye" />
									</button>
									{email.status === 'failed' && (
										<button
											className="btn btn-success"
											onClick={() => onRetry(email.id)}
											title="Retry"
										>
											<i className="bi bi-arrow-clockwise" />
										</button>
									)}
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default EmailTable;
